/**
 * Facebook Pixel tracking function
 * https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking/
 * Safely calls fbq if it's available in the global scope
 * @param action - The action to perform (e.g., 'trackCustom', 'track', 'init')
 * @param eventName - The name of the event to track
 * @param params - Optional parameters to pass to the event
 * @param opts - Optional 4th param for deduplication: { eventID: 'uuid' }
 *   https://developers.facebook.com/docs/marketing-api/conversions-api/deduplicate-pixel-and-server-events/
 */
export const fbq = ({
  action,
  eventName,
  params,
  opts,
}: {
  action: string
  eventName: string
  params?: Record<string, unknown> | null
  opts?: { eventID?: string } | null
}): void => {
  if (typeof window !== 'undefined' && typeof window.fbq !== 'undefined') {
    if (opts?.eventID !== undefined) {
      window.fbq(action, eventName, params ?? null, opts)
    } else if (params) {
      window.fbq(action, eventName, params)
    } else {
      window.fbq(action, eventName)
    }
  }
}

/**
 * Pushes an event to the Google Tag Manager dataLayer if available.
 * This is used for tracking events in Google Analytics and other marketing platforms via GTM.
 *
 * @param event - The name of the event to be pushed to the dataLayer
 */
export const dataLayerPush = (event: string): void => {
  if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: event,
    })
  }
}
